import {
    AcceptIcon,
    ChevronDownIcon,
    FilesSketchIcon,
    Flex,
    Image,
    Text,
} from "@fluentui/react-northstar";
import { useState } from "react";
import Card from "./Card";
import styled from "styled-components";
import { CheckmarkStarburst20Filled } from "@fluentui/react-icons";
import Toast from "../../../components/Alerts";
import EmptyTodoTask from "../img/EmptyTodoTask.png";
import { TASK_ACTIONS } from "../../../constants/tasks";

const DocumentUploaded = ({
    state,
    setstate,
    status,
    lengthdone,
    done,
    isLoading,
    isFetching,
}) => {
    const [configToast, setConfigToast] = useState({
        visible: false,
        content: "",
        level: "warning",
    });

    return (
        <Flex column>
            <HeaderDone
                fill
                vAlign="center"
                space="between"
                onClick={() => setstate(!state)}
            >
                <Toast
                    level={configToast.level}
                    content={configToast.content}
                    visible={configToast.visible}
                    onStatusChange={() =>
                        setConfigToast({
                            visible: false,
                            content: "",
                            level: "warning",
                        })
                    }
                />
                <LeftHeaderDone vAlign="center">
                    <FilesSketchIcon />
                    <HeaderTextDone content="Actions terminées" />
                </LeftHeaderDone>
                <RightHeader vAlign="center">
                    <ChevronDownIcon
                        outline
                        style={{
                            color: "#616161",
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                        }}
                        rotate={state ? 180 : 0}
                    />
                </RightHeader>
            </HeaderDone>
            {state ? (
                <ContentDone column>
                    <Flex column hAlign="center" fill>
                        {lengthdone === 0 ? (
                            <Flex
                                gap="gap.medium"
                                vAlign="center"
                                hAlign="center"
                                fill
                                column
                            >
                                <Image src={EmptyTodoTask} />
                                {/* <Title content="Toutes les actions ont été effectuées" /> */}
                                <Title content="Absence d'actions terminés " />
                                <DescriptionText content="Vous receverez un mail en cas d'autres actions à faire" />
                            </Flex>
                        ) : (
                            done?.map((el) => {
                                return (
                                    <Card
                                        el={el}
                                        isPrimary={true}
                                        ButtonIcon={null}
                                        action={
                                            TASK_ACTIONS.find(
                                                (action) =>
                                                    action.id ===
                                                    el?.document_action
                                            )?.element
                                        }
                                        actionText={el?.name}
                                        icon={
                                            <AcceptIcon
                                                styles={{
                                                    color: "var(--green)",
                                                }}
                                                size="small"
                                            />
                                        }
                                        due_date={el?.due_date}
                                        isLoading={isLoading}
                                        isFetching={isFetching}
                                        status={status}
                                        $isDone={true}
                                    />
                                );
                            })
                        )}
                        {/*  */}
                    </Flex>
                </ContentDone>
            ) : null}
        </Flex>
    );
};

export default DocumentUploaded;

const ContentDone = styled(Flex)`
    overflow-y: scroll;
    max-height: 541px;
    height: 100%;
`;

const HeaderTextDone = styled(Text)`
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-tert);
`;

const HeaderDone = styled(Flex)`
    padding: 11px 18px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-tert);
    :hover {
        ${HeaderTextDone} {
            color: var(--text-sec);
        }
    }
`;

const LeftHeaderDone = styled(Flex)`
    color: white;
    gap: 12px;
`;

const RightHeader = styled(Flex)`
    gap: 14px;
`;

const Title = styled(Text)`
    color: #000;
    text-align: center;
    width: 250px;

    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
`;

const DescriptionText = styled(Text)`
    color: #242424;
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    width: 250px;
`;
